<template>
    <div class="video-des p-r">
        <div class="video-btn-wrap m-0-a">
            <a href="javascript:;" :class="[{'mine':index == '1'},'d-i-b']" v-for="(item,index) in info.topList" :key="index" @click="chooseVideo(item,index)">
                <img :src="item.src" alt="">
            </a>
        </div>
        <div class="video-url-wrap m-0-a p-r" :style="{background: 'url(' + info.videoBg + ')  center 0 no-repeat;background-size: cover;' }">
            <img class="video-pic" :src="videoPic" alt="">
            <a href="javascript:;" class="play-btn p-a" @click="play = true">
                <img :src="info.videoPlayBtn" alt="">
            </a>
            <transition name="fade">
                <div class="video-wrap p-f" v-show="play">
                    <div class="video p-a">
                        <a href="javascript:;" class="close d-b p-a" @click="playVodeo"></a>
                        <iframe scrolling="no" frameborder="0" :src="videoSrc+'?rel=0&amp;autoplay=1'" width="100%" height="100%"></iframe>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .video-btn-wrap {
        width: 9.6rem;
        margin: 0 auto .066667rem;
        a {
            width: 3.093333rem;
            height: 1.2rem;
        }
        .mine {
            margin: 0 .16rem;
        }
    }
    .video-url-wrap {
        width: 9.653333rem;
        height: 5.466667rem;
        margin-bottom: .346667rem;
        .video-pic {
            width: 100%;
            height: 100%;
        }
        .play-btn {
            width: 2.64rem;
            height: 2.24rem;
            top: 50%;
            left: 50%;
            margin: -1.12rem 0 0 -1.32rem;
            z-index: 2;
        }
        .video-wrap {
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, .8);
            z-index: 2;
        }
        .video {
            width: 9.653333rem;
            height: 5.466667rem;
            top: 50%;
            left: 50%;
            margin: -2.7333rem 0 0 -4.825rem;
            .close {
                width: .6rem;
                height: .6rem;
                right: 0;
                top: -.6rem;
                &::before,
                &::after {
                    content: '';
                    width: .6rem;
                    height: 3px;
                    background: #ffffff;
                    position: absolute;
                    top: 50%;
                }
                &::before {
                    left: 0;
                    transform: rotate(45deg)
                }
                &::after {
                    right: 0;
                    transform: rotate(135deg)
                }
            }
        }
    }
    img {
        max-width: 100%;
    }
</style>
<script>
    import Util from "@util/index.js";
    export default {
        props: ['info', 'lan'],
        data() {
            return {
                play: false,
                videoPic: '',
                videoSrc: '',
                index: 0 //视频索引
            }
        },
        mounted() {
            this.videoSrc = this.info.topList[0].videoSrc;
            this.videoPic = this.info.topList[0].videoPic;
        },
        methods: {
            chooseVideo(_info, _index) {
                this.videoSrc = _info.videoSrc;
                this.videoPic = _info.videoPic;
                this.index = _index;
            },
            playVodeo() {
                this.play = false;
                Util.trackGA('点击', this.lan + '点击第' + (this.index + 1) + '视频播放按钮', this.lan + '点击第' + (this.index + 1) + '视频播放按钮');
            }
        }
    }
</script>





// WEBPACK FOOTER //
// client/smsgz/components/index/video-des.vue